<template>
  <div class="mask review" v-show="dialogVisibled">
    <el-dialog
      :visible.sync="dialogVisibled"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :modal="false"
      custom-class="dialog"
      :center="true"
      title="审核结果"
    >
      <div class="box">
        <span class="tips">是否通过审核</span>
        <input
          class="mui-switch mui-switch-animbg"
          v-model="result"
          type="checkbox"
        />
        <div
          class="violating-goods"
          v-if="$route.name === 'goodsCheck'"
          v-show="!result"
        >
          <p
            v-for="(item, index) in violation"
            :key="index"
            class="box"
            :class="`color${index + 1}`"
          >
            <el-input
              v-model="item.violation_reason"
              placeholder="请输入"
              clearable
            >
              <template slot="prepend">
                {{ item.violation_type }}
              </template>
            </el-input>
          </p>
        </div>
        <el-input
          v-else
          type="textarea"
          v-model="textarea"
          clearable
          size="360"
          resize="none"
          placeholder="请输入未通过原因"
          v-show="!result"
          :autosize="{ minRows: 5, maxRows: 7 }"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="98"
          class="sub-color"
          @click="sendCheckStatus"
          v-html="result ? '确定' : '驳回'"
        />
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Review',
  props: {
    funcName: {
      type: String
    }
  },
  data() {
    return {
      dialogVisibled: false,
      textarea: '',
      result: false,
      violation: [
        {
          violation_type: '1',
          violation_reason: ''
        },
        {
          violation_type: '2',
          violation_reason: ''
        },
        {
          violation_type: '3',
          violation_reason: ''
        },
        {
          violation_type: '4',
          violation_reason: ''
        }
      ]
    }
  },
  methods: {
    /**
     * 改变弹框状态
     * @param val
     * @param vm
     */
    _changePopStatus(val, vm) {
      this.parentInstance = vm
      this.dialogVisibled = !this.dialogVisibled
      if (Array.isArray(val)) {
        this.id = val.map(v => {
          return v.id
        })
        return
      }
      this.id = val.id
      this.email = val.email
      this.phone = val.phone
    },
    /**
     * 发送审核状态
     */
    sendCheckStatus() {
      const routeName = this.$route.name
      const data = {}
      switch (routeName) {
        case 'brandManagement':
          data.brand_id = this.id
          break
        case 'vipCheck':
          data.apply_id = this.id
          break
        case 'distributorCheck':
          data.distributor_id = this.id
          break
        case 'commisionWithdrawal':
          data.apply_id = this.id
          break
        case 'materialReview':
          data.material_id = this.id
          break
        case 'companyCheck':
          data.merchant_id = this.id
          data.mail_box = this.email
          data.mobile_phone = this.phone
          break
        case 'goodsCheck':
          data.goods_id = this.id
          break
      }
      if (this.result) {
        if (routeName !== 'companyCheck') {
          data.audit_status = 2
        } else {
          data.merchant_state = 2
        }
        this.sendRequest(data, routeName).then(() => {
          this.$notify({
            type: 'success',
            message: '审核通过~！'
          })
        })
      } else {
        if (this.$route.name !== 'goodsCheck') {
          if (this.textarea === '') {
            this.$notify({
              type: 'warning',
              title: '驳回理由不能为空!'
            })
            return
          }
          data.rejection_reason = this.textarea
        } else {
          const violation = this.violation.filter(v => {
            return v.violation_reason !== ''
          })
          if (violation.length === 0) {
            this.$notify({
              type: 'warning',
              title: '请输入一条驳回理由~！🤔'
            })
            return
          }
          data.violation_instructions = violation
        }
        if (routeName !== 'companyCheck') {
          data.audit_status = 3
        } else {
          data.merchant_state = 3
        }
        this.sendRequest(data, routeName).then(() => {
          this.$notify({
            type: 'success',
            message: '驳回成功~！'
          })
        })
      }
    },
    /**
     * 调用接口
     * @param data
     * @param routeName
     */
    sendRequest(data, routeName) {
      return this.api[this.funcName](data).then(res => {
        this.dialogVisibled = false
        this.result = false
        // 刷新数据
        this.parentInstance._notifyEmit('check', (vm, newVal, type) => {
          const instance = type !== 'tableData' ? vm[type] : vm
          const data = {
            curpage: instance.pagination.currentPage,
            audit_status: vm.activeName
          }
          switch (routeName) {
            case 'brandManagement':
              vm._getBrandData(data, type)
              break
            case 'vipCheck':
              vm._getSommelierList(data, type)
              break
            case 'distributorCheck':
              vm._getDistributorList(data)
              break
            case 'commisionWithdrawal':
              vm._commissionWithdrawalList(data)
              break
            case 'materialReview':
              vm._getMaterialList(data)
              break
            case 'companyCheck':
              data.merchant_state = vm.activeName
              vm._getMerchantList(data)
              break
            case 'goodsCheck':
              this.violation = [
                {
                  violation_type: '1',
                  violation_reason: ''
                },
                {
                  violation_type: '2',
                  violation_reason: ''
                },
                {
                  violation_type: '3',
                  violation_reason: ''
                },
                {
                  violation_type: '4',
                  violation_reason: ''
                }
              ]
              vm._getMerchantGoodsList(data)
              break
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
.review {
  .el-dialog__title {
    font-weight: bold;
  }

  .box {
    text-align: center;
  }

  .tips {
    display: inline-block;
    color: #010101;
    margin-bottom: 2.5rem;
    margin-right: 1rem;
  }

  .el-input--360 {
    width: 22.5rem;
    display: block;
    margin: 0 auto;

    .el-textarea__inner {
      background-color: #f7f7f7;
      border: 0;
      min-height: 13rem !important;
    }
  }

  .violating-goods {
    .el-input {
      width: 23rem;
    }
  }
}
</style>
